import { useQuery } from '@tanstack/react-query';

import CustomerService from '@/services/CustomerService';

export const GET_CUSTOMER_BY_ID_QUERY_KEY = (id: number) => [
  'customer-by-id',
  id,
];

export function useGetCustomerById(id: number) {
  const { data, isFetching } = useQuery({
    queryKey: GET_CUSTOMER_BY_ID_QUERY_KEY(id),
    queryFn: () => CustomerService.getCustomerById(id),
    enabled: !!id,
  });

  return {
    customer: data,
    customerLoading: isFetching,
  };
}
